// src/constants/stockStatus.js

/**
 * Stock status enum matching the Swift StockStatus
 * Located at: /Users/davin/HotwireAppProject/OrderPlatform/StockStatus.swift
 */
export const StockStatus = {
  IN_STOCK: 'In Stock',
  OUT_OF_STOCK: 'Out of Stock',
};

/**
 * Check if a stock status value indicates the product is in stock
 * @param {string} stockStatus - The stock status string
 * @returns {boolean} True if the product is in stock
 */
export const isInStock = (stockStatus) => {
  return stockStatus === StockStatus.IN_STOCK;
};

/**
 * Check if a stock status value indicates the product is out of stock
 * @param {string} stockStatus - The stock status string
 * @returns {boolean} True if the product is out of stock
 */
export const isOutOfStock = (stockStatus) => {
  return stockStatus === StockStatus.OUT_OF_STOCK;
};
